import type { GroupPlanIdsByFolderKey } from "./types";

export const groupPlanIdsByFolderKey: GroupPlanIdsByFolderKey = ({
  drafts,
}) => {
  const planIdsByFolderKey = new Map<string | null, number[]>();
  for (const [floorPlanId, folderKey] of drafts.folderKeyByPlanId) {
    const planIds = planIdsByFolderKey.get(folderKey);
    if (planIds === undefined) planIdsByFolderKey.set(folderKey, [floorPlanId]);
    else planIds.push(floorPlanId);
  }
  return planIdsByFolderKey;
};
